module.exports = __webpack_public_path__ + "img/mp.d9b1a764.png";